import React from "react";
import './solutionsherosection.component.css';
import BookDemoButton from "../../../../BookDemoButton";
import { Link } from "react-router-dom";

const SolutionsHeroSection = () => {
  return (
    
    <section className="position-relative pt-5 overflow-hidden">
      <div className="container position-relative mt-5 pt-xl-5 pt-md-3 zindex-5">
      {/* Breadcrumb */}
                <nav className="pt-5" aria-label="breadcrumb">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">Services</li>
                  </ol>
                </nav>
        <div className="row justify-content-md-start justify-content-center flex-md-nowrap pt-lg-5 pt-4">
          <div className="col-xl-7 col-md-7 col-sm-10 d-flex flex-column justify-content-between mb-md-5 mb-md-4 mb-3 pb-xl-5 pb-lg-4">
            <div className="text-md-start text-center">
              <h2 className="services-h2 mb-lg-4 mb-3 fw-lighter">
                World-Class Expertise. <br />
                Empowered by AI. <br />
                Available Anywhere, On Demand.
              </h2>
              <p className="mb-4 mx-md-0 mx-auto pb-xl-3 pb-lg-2 fs-lg">
               <span className="text-primary">Orbix delivers</span> full-scope NDT Auditing and Management, combining our elite network of Level III experts with advanced AI through our digital platform. Get instant, real-time oversight anywhere, ensuring unparalleled quality control, regulatory readiness, and actionable insights to optimize your projects and vendor performance.
              </p>
             <BookDemoButton label="Schedule Your Personalized Demo" id="bookaDemo2" />

            </div>
          </div>
          <div className="col-md-12 offset-xl-1 d-flex mb-4 justify-content-md-start justify-content-center ">
          <div className="align-self-end ms-xl-0 ms-md-4 p-lg-4 p-sm-3 p-2 overflow-hidden">
              <img
                src="assets/services_img/services_hero.png"
                alt="Layer"
                className="img-fluid"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </div>
          </div>
        </div>
      </div>
      <span className="position-absolute bottom-0 start-0 w-100">
        <span className="d-dark-mode-none d-block w-100 h-100 py-xl-5 pt-lg-4 pt-md-0 pt-4 pb-5 bg-light"></span>
        <span className="d-dark-mode-block d-none w-100 h-100 py-xl-5 pt-lg-4 pt-md-0 pt-4 pb-5 bg-dark"></span>
      </span>
    </section>
  );
};

export default SolutionsHeroSection;